import {
  KpiGrid,
  KpiCard,
  KpiCardBankDetails,
  KpiCardSynced1C,
  KpiCardSuppliers,
  KpiLabel,
  KpiValue,
  KpiSub,
} from './styled';
import type { CounterpartyKpiMetrics } from './types';

interface CounterpartyKpiGridProps {
  metrics: CounterpartyKpiMetrics;
  /** Справочник ещё грузится или не загрузился: чисел нет, а не нули. */
  status: 'loading' | 'error' | 'ready';
}

export function CounterpartyKpiGrid({ metrics, status }: CounterpartyKpiGridProps) {
  const ready = status === 'ready';
  const value = (n: number) => (ready ? n.toLocaleString('ru-RU') : status === 'loading' ? '…' : '—');
  // Показатели по карточкам считаются по загруженным; если загружены не все — так и пишем
  const partial = metrics.countedCount < metrics.totalCount;
  const scope = (text: string) =>
    !ready
      ? status === 'loading'
        ? 'Загрузка справочника…'
        : 'Справочник не загрузился'
      : partial
        ? `${text} — по первым ${metrics.countedCount.toLocaleString('ru-RU')}`
        : text;
  return (
    <KpiGrid>
      <KpiCard>
        <KpiLabel>Всего контрагентов</KpiLabel>
        <KpiValue>{value(metrics.totalCount)}</KpiValue>
        <KpiSub>{ready ? 'В мастер-справочнике' : scope('')}</KpiSub>
      </KpiCard>
      <KpiCardBankDetails>
        <KpiLabel>С полными реквизитами</KpiLabel>
        <KpiValue>{value(metrics.withBankDetailsCount)}</KpiValue>
        <KpiSub>{scope('ИНН, счёт из 20 цифр и БИК — хватает для платёжки')}</KpiSub>
      </KpiCardBankDetails>
      <KpiCardSynced1C>
        <KpiLabel>Пришли из 1С</KpiLabel>
        <KpiValue>{value(metrics.synced1CCount)}</KpiValue>
        <KpiSub>{scope('Синхронизация, передача и файлы 1С')}</KpiSub>
      </KpiCardSynced1C>
      <KpiCardSuppliers>
        <KpiLabel>Поставщики и подрядчики</KpiLabel>
        <KpiValue>{value(metrics.activeSuppliersCount)}</KpiValue>
        <KpiSub>{scope('Основной производственный контур')}</KpiSub>
      </KpiCardSuppliers>
    </KpiGrid>
  );
}
